// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"8439200f","453":"1f1396d6","726":"7b005202","806":"0c8db3cf"}[chunkId] + ".chunk.js";
};